import { useMessages } from '@hooks/useMessages';
import React from 'react';
import { Button, DropdownItem } from 'reactstrap';
import { ArrowLeft } from 'react-feather';

interface QrScannerBackButtonProps {
  message: string;
  onBack: () => void;
}

export const QrScannerBackButton: React.FC<QrScannerBackButtonProps> = ({
  message,
  onBack,
}) => {
  const { messages } = useMessages();

  return (
    <DropdownItem header className="d-flex align-items-center">
      <Button
        color="transparent"
        size="sm"
        className="p-50 ml-n50 mr-50"
        onClick={onBack}
        aria-label={messages('action_back')}
      >
        <ArrowLeft />
      </Button>
      <span>{message}</span>
    </DropdownItem>
  );
};

export default QrScannerBackButton;
